const SITEMAP_SCREEN = 'SitemapScreen';
const TERMS_SCREEN = 'TermsScreen';
const PRIVACY_SCREEN = 'PrivacyScreen';
const ERROR_SCREEN = 'ErrorScreen';

export {
    SITEMAP_SCREEN,
    TERMS_SCREEN,
    PRIVACY_SCREEN,
    ERROR_SCREEN
};
